import React from 'react';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import { showToast } from '@deeptrue-frontend/ui';
import { FormattedMessage } from 'react-intl';

import { FormikHelpers } from 'formik';
import { FormValues } from 'components/Forms/Profile';
import { translateFieldErrors } from 'components/IntlProvider/translateFieldErrors';
import { useFormatMessage } from 'components/IntlProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { Dashboard } from 'components/Layout';
import Forms from 'components/Forms';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import api from 'api/api';
import SettingsMenu from './SettingsMenu';

const { connect, actions, selectors } = StoreProvider;

const Settings = ({ updateUserProfile, location, initialValues }: any) => {
  const t = useFormatMessage();

  const updateProfile = (
    values: FormValues,
    { setErrors }: FormikHelpers<FormValues>
  ) => {
    const preparedData = {
      ...values,
      language: values.language.toString(),
    };

    return api.resources
      .updateUserProfile(preparedData)
      .then(({ data }) => {
        updateUserProfile(data);

        showToast({
          type: 'success',
          // INFO use formatmessage as hooks have delay with changing lang, notification was always provided in old language, in formatMessage this problem doesnt occurs
          /* eslint-disable-next-line */
          // @ts-ignore
          title: <FormattedMessage id="errors.settings.changesSave" />,
        });
      })
      .catch((err) => {
        setErrors(
          translateFieldErrors({
            t,
            err: err.response.data,
          })
        );
      });
  };

  return (
    <Dashboard
      title={t('profile.title', 'Settings')}
      headerTitle={t('profile.headerTitle', 'Profile')}
      headerSubtitle={t(
        'profile.headerSubtitle',
        'Here you can find information about your profile'
      )}
      location={location}
    >
      <Grid item xs={12}>
        <SettingsMenu />
      </Grid>
      <Grid item xs={12} sm={12} md={10} lg={6}>
        <Forms.Profile onSubmit={updateProfile} initialValues={initialValues} />
      </Grid>
    </Dashboard>
  );
};

export default compose(
  connect(
    (state) => ({
      initialValues: selectors.authSelectors.userProfileData(state),
    }),
    {
      updateUserProfile: actions.authActions.userUpdate,
    }
  ),
  withMetaDescription({ title: 'Settings > Profile' })
)(Settings);
